export const edit_alt = () => (
  <path
    d="m20.338 8.108-4.446-4.446M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7m-13-.446V17h4.446l9.633-9.633a3.144 3.144 0 0 0-4.446-4.446z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
